module.exports = __webpack_public_path__ + "static/hero-tape-fa2e878c7da984785979b67b22f241f0.webp";